import ProductTag from './ProductTag'

export default ProductTag
